"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateRequiresServiceFeesIntegratedIntoPricing = void 0;
const usStatesAndTerritories_1 = require("../../locations/usStatesAndTerritories");
/**
 * The client service fee should be included in the total amount owed - and should not be a separate line item in itemized invoices and receipts
 */
const StatesWhereServiceFeesMustBeIntegratedIntoPricing = [
    usStatesAndTerritories_1.UnitedStatesStateTerritoryKey.California,
    usStatesAndTerritories_1.UnitedStatesStateTerritoryKey.Kansas,
    usStatesAndTerritories_1.UnitedStatesStateTerritoryKey.NewYork,
    usStatesAndTerritories_1.UnitedStatesStateTerritoryKey.Texas,
];
/**
 * Determines if we need to integrate the fee into pricing
 * @param state
 * @returns
 */
const StateRequiresServiceFeesIntegratedIntoPricing = (state) => StatesWhereServiceFeesMustBeIntegratedIntoPricing.includes(state);
exports.StateRequiresServiceFeesIntegratedIntoPricing = StateRequiresServiceFeesIntegratedIntoPricing;
//# sourceMappingURL=StateRequiresServiceFeesIntegratedIntoPricing.js.map